<syslink-title text="Customers"></syslink-title>

<app-customer-grid
  [permissionKey]="'list'"
  [canUpdate]="false"
  [canDelete]="false"
  (add)="onAddButtonClicked()"
  (rowDoubleClicked)="onRowDoubleClicked($event)"
></app-customer-grid>